import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaCalendarAlt,
  FaUser,
  FaFacebook,
  FaTwitter,
  FaWhatsapp,
  FaLink,
  FaShareAlt,
  FaTimes,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";
import "../css/DetailBlog.css";
import { formatDateTime } from "../helpers/dateFormat";
import { useTranslation } from "react-i18next";

const DetailBlog = () => {
  const { t, i18n } = useTranslation();
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shareOpen, setShareOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const currentUrl = window.location.href;

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APP_URL}/blogs/${slug}`,
          {
            headers: {
              "X-Platform": process.env.REACT_APP_X_PLATFORM,
              "API-Key": process.env.REACT_APP_API_KEY,
              "X-API-Version": process.env.REACT_APP_X_API_VERSION,
            },
            withCredentials: true,
          },
        );
        if (response.data.success) {
          setBlog(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching blog data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug, i18n.language, t]);

  if (loading) {
    return (
      <div className="container text-center mt-5">
        <p>Loading...</p>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="container text-center mt-5">
        <p>Blog tidak ditemukan!</p>
      </div>
    );
  }

  const imageUrl = blog.image
    ? `${process.env.REACT_APP_STORAGE_URL}/${blog.image}`
    : "";

  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    currentUrl,
  )}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    currentUrl,
  )}&text=${encodeURIComponent(blog.title)}`;
  const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
    blog.title + " " + currentUrl,
  )}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  return (
    <div className="container" style={{ marginTop: "60px" }}>
      <div className="card shadow-lg border-0 rounded-4 p-4 animate__animated animate__fadeIn">
        {blog.image && (
          <img
            src={imageUrl}
            alt={blog.title}
            className="card-img-top rounded blog-image"
          />
        )}
        <div className="card-body">
          <h2 className="fw-bold text-primary">{blog.title}</h2>
          <p className="text-muted small d-flex align-items-center">
            <FaUser className="me-1 text-primary" /> {blog.user_name} &nbsp; |
            &nbsp;
            <FaCalendarAlt className="me-1 text-primary" />{" "}
            {formatDateTime(blog.created_at)}
          </p>
          <div
            className="text-dark mt-3 blog-content"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          ></div>
        </div>
      </div>

      <div className={`share-container ${shareOpen ? "open" : ""}`}>
        <button
          className="share-button"
          onClick={() => setShareOpen(!shareOpen)}
        >
          {shareOpen ? <FaTimes /> : <FaShareAlt />}
        </button>

        {shareOpen && (
          <div className="share-options">
            <a
              href={facebookShareUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="share-option facebook"
            >
              <FaFacebook />
            </a>
            <a
              href={twitterShareUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="share-option twitter"
            >
              <FaTwitter />
            </a>
            <a
              href={whatsappShareUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="share-option whatsapp"
            >
              <FaWhatsapp />
            </a>
            <button className="share-option copy" onClick={copyToClipboard}>
              <FaLink />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailBlog;
